import React, { useState, useEffect, useMemo } from 'react';

import ReactLoading from 'react-loading';

import {
  getGlobalSumMonthTrends, getDetailedSumMonthTrends, getAvgMonthTrends,
  getGlobalSumWeekTrends, getDetailedSumWeekTrends, getAvgWeekTrends,
  getGlobalSumDayTrends, getDetailedSumDayTrends, getAvgDayTrends,
  getAllAgencies, getUser, getUserAgency,
  getRoutes
} from '../API';

import {
  handleDayTypeClick,
  handlePeriodClick,
  handleRouteClick,
  checkFilterCookies,
  updateFilterCookies,
  deleteFilterCookies,
  handleMultiRoutes,
} from '../helpers/filterHelpers.js'

import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import TuneIcon from '@mui/icons-material/Tune';
import ClearIcon from '@mui/icons-material/Clear';
import BarChartIcon from '@mui/icons-material/BarChart';
import SsidChartIcon from '@mui/icons-material/SsidChart';

import { translateAll, revertOne } from '../helpers/benchmarkHelpers.js'

import TrendsDrawer from '../components/Drawers/TrendsDrawer.js';
import FilterCard from '../components/Dashboard/FilterCard.js';

import {
  ComposedChart,
  BarChart,
  CartesianGrid, Bar, Line,
  XAxis, YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import { useTranslation } from "react-i18next";

const Trends = () => {

  const { t } = useTranslation('common');

  const colorGradient = ['#79508f', '#ba5b90', '#ec7182', '#ff966e', '#ffc562', '#f9f871'];

  //kpis
  const [dailySumTrends, setDailySumTrends] = useState([]);
  const [weeklySumTrends, setWeeklySumTrends] = useState([]);
  const [monthlySumTrends, setMonthlySumTrends] = useState([]);

  const [dailyAvgTrends, setDailyAvgTrends] = useState([]);
  const [weeklyAvgTrends, setWeeklyAvgTrends] = useState([]);
  const [monthlyAvgTrends, setMonthlyAvgTrends] = useState([]);

  const [routes, setRoutes] = useState([]);

  //Filters
  //const [service, setService] = useState(checkFilterCookies()[0].service ? checkFilterCookies()[0].service : 'tous');
  const [service, setService] = useState('tous');
  const [period, setPeriod] = useState('all');
  //const [selectedRoutes, setSelectedRoutes] = useState(checkFilterCookies()[0].route ? checkFilterCookies()[0].route : ['all']);
  const [selectedRoutes, setSelectedRoutes] = useState(['all']);


  //Filter visuals

  const [serviceV, setServiceV] = useState('');
  const [periodV, setPeriodV] = useState(t('compareperiods.all'));
  const [selectedRoutesV, setSelectedRoutesV] = useState('');

  //graph series
  const [selectedSeries, setSelectedSeries] = useState([]);
  const [selectedAvgSeries, setSelectedAvgSeries] = useState([]);
  const [dataKey, setDataKey] = useState('month');
  const [alignedSeries, setAlignedSeries] = useState('');
  const [joinSeries, setJoinSeries] = useState('');
  const [bars, setBars] = useState('');

  const [user, setUser] = useState('');
  const [agency, setAgency] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [userAgency, setUserAgency] = useState('');

  const [kpiKeys, setKpiKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState('rtvehhours');
  const [translatedKey, setTranslatedKey] = useState(t('dashboard.kpi.aveh-h'));

  const [monthToggle, setMonthToggle] = useState('contained');
  const [weekToggle, setWeekToggle] = useState('outlined');
  const [dayToggle, setDayToggle] = useState('outlined');

  const [lineToggle, setLineToggle] = useState('contained');
  const [barToggle, setBarToggle] = useState('outlined')

  const [refreshKey2, setRefreshKey2] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  // const [refreshKey1, setRefreshKey1] = useState(0);

  const [loading, setLoading] = useState(0);
  const [recalcAvg, setRecalcAvg] = useState(false);

  const [open, setOpen] = useState(false);

  const [firstLoad, setFirstLoad] = useState(1);


  //Get filters from cookies
  useEffect(() => {

    let serviceCookie = checkFilterCookies()[0].service;
    let routesCookie = checkFilterCookies()[0].route;

    //Set card value for service
    if (serviceCookie && (serviceCookie == 'tous' || serviceCookie == 'all' || serviceCookie == t('compareperiods.all'))) {
      setServiceV(t('compareperiods.all'))
    } else if (serviceCookie && (serviceCookie == 'se' || serviceCookie == t('compareperiods.week'))) {
      setServiceV(t('compareperiods.week'))
    } else if (serviceCookie && (serviceCookie == 'fds' || serviceCookie == t('compareperiods.weekends'))) {
      setServiceV(t('compareperiods.weekends'))
    } else {
      setServiceV(t('compareperiods.all'))
    }


    //Set card value for routes
    setSelectedRoutesV(routesCookie && routesCookie.includes('all') ? t('compareperiods.all') :
      selectedRoutes == 'all' || selectedRoutes == t('compareperiods.all') ? t('compareperiods.all') :
        selectedRoutes);

  }, [])


  //Get agencies
  useEffect(() => {

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency()
      .then(response => {
        setUserAgency(response);
      })
  }, []);

  useEffect(() => {
    getRoutes(agency)
      .then(response => {
        setRoutes(response);
      });
  }, [refreshKey2]);


  //Get and set data
  useEffect(() => {

    //don't run this on first page load
    if (firstLoad == 0) {

      setLoading(1);

      let promiseArray = [];

      if (selectedRoutes.includes('all') || selectedRoutes.length == routes.length || selectedRoutes.length == 0) {
        promiseArray = [
          getGlobalSumMonthTrends(agency, service, period),
          getGlobalSumWeekTrends(agency, service, period),
          getGlobalSumDayTrends(agency, service, period)
        ];
      } else {
        promiseArray = [
          getDetailedSumMonthTrends(agency, selectedRoutes, service, period),
          getDetailedSumWeekTrends(agency, selectedRoutes, service, period),
          getDetailedSumDayTrends(agency, selectedRoutes, service, period)
        ];
      }

      if (recalcAvg == true) {
        promiseArray = [
          ...promiseArray,
          getAvgMonthTrends(agency, service, period),
          getAvgWeekTrends(agency, service, period),
          getAvgDayTrends(agency, service, period)
        ]
      }

      Promise.all(promiseArray)
        .then(([monthResponse, weekResponse, dayResponse,
          avgMonthResponse, avgWeekResponse, avgDayResponse
        ]) => {

          // set Avgs
          if (avgMonthResponse && avgWeekResponse && avgDayResponse) {
            setMonthlyAvgTrends(avgMonthResponse);
            setWeeklyAvgTrends(avgWeekResponse);
            setDailyAvgTrends(avgDayResponse);
          }

          // KPIs
          let kpiKeys = Object.keys(monthResponse[0]);
          kpiKeys.splice(0, 2);
          let translated = translateAll(kpiKeys, t);
          setKpiKeys(translated);

          // Month data
          setMonthlySumTrends(monthResponse);

          // Week data
          setWeeklySumTrends(weekResponse);

          // Day data
          setDailySumTrends(dayResponse);

          // Set corresponding data
          if (dataKey == 'month') {
            setSelectedSeries(monthResponse);
            setSelectedAvgSeries(monthResponse);
            let graphData = alignData(monthResponse, avgMonthResponse ? avgMonthResponse : monthlyAvgTrends, selectedKey);
            let joinedData = joinData(monthResponse, avgMonthResponse ? avgMonthResponse : monthlyAvgTrends, selectedKey);
            setAlignedSeries(graphData);
            setJoinSeries(joinedData);

          } else if (dataKey == 'week') {
            setSelectedSeries(weekResponse);
            setSelectedAvgSeries(weekResponse);
            let graphData = alignData(weekResponse, avgWeekResponse ? avgWeekResponse : weeklyAvgTrends, selectedKey);
            let joinedData = joinData(weekResponse, avgWeekResponse ? avgWeekResponse : weeklyAvgTrends, selectedKey);
            setAlignedSeries(graphData);
            setJoinSeries(joinedData);

          } else if (dataKey == 'day') {
            setSelectedSeries(dayResponse);
            setSelectedAvgSeries(dayResponse);
            let graphData = alignData(dayResponse, avgDayResponse ? avgDayResponse : dailyAvgTrends, selectedKey);
            setAlignedSeries(graphData);
          }

          setLoading(0);
          setRecalcAvg(false);

        })
        .catch(error => {
          // Handle error
          console.error("Error fetching data:", error);
        });

    }

  }, [refreshKey]);


  function handleKPISelect(e) {
    let result = revertOne(e.target.value, t);
    setTranslatedKey(e.target.value);
    setSelectedKey(result);
    let graphData = alignData(selectedSeries, selectedAvgSeries, result);
    let joinedData = joinData(selectedSeries, selectedAvgSeries, result);
    setAlignedSeries(graphData);
    setJoinSeries(joinedData)
  }


  function alignData(sumSeries, avgSeries, key) {

    const alignedData = [];

    if (selectedRoutes.includes('all') == false || (selectedRoutes.length > 1 && selectedRoutes.length < routes.length)) {

      avgSeries.forEach((i) => {
        let date = i.chartlabel;
        let val1 = i[key];
        let val2 = sumSeries.find((e) => e.chartlabel === i.chartlabel) ? sumSeries.find((e) => e.chartlabel === i.chartlabel)[key] : 0;
        let variation = sumSeries.find((e) => e.chartlabel === i.chartlabel) ? sumSeries.find((e) => e.chartlabel === i.chartlabel)[key + '_pct'] : 0;


        alignedData.push({
          date: date,
          value1: val1,
          value2: val2,
          variation: variation
        })
      })

    } else {

      sumSeries.forEach((i) => {
        let date = i.chartlabel;
        let val2 = i[key];
        let variation = i[key + '_pct'];

        alignedData.push({
          date: date,
          value2: val2,
          variation: variation
        })
      })
    }

    return alignedData

  }

  function joinData(sumSeries, avgSeries, key) {

    const result = {};

    const allYears = new Set(sumSeries.map(item => item.year));

    if (dataKey == "month") {
      // Initialize result with all months and all years set to 0
      for (let month = 1; month <= 12; month++) {
        result[month] = { month };
        allYears.forEach(year => {
          result[month][year] = 0;
        });
      }

      // Populate result with actual data
      sumSeries.forEach(({ year, month, ...kpis }) => {
        result[month][year] = kpis[key]; // Dynamically assign the KPI value for the year
      });

      let barSeries = [...new Set(Object.values(result).flatMap(obj => Object.keys(obj)).filter(key => key !== "month"))];
      setBars(barSeries);

      return Object.values(result);

    } else if (dataKey == "week") {

      for (let week = 1; week <= 52; week++) {
        result[week] = { week };
        allYears.forEach(year => {
          result[week][year] = 0;
        });
      }

      // Populate result with actual data
      sumSeries.forEach(({ year, week, ...kpis }) => {
        result[week][year] = kpis[key]; // Dynamically assign the KPI value for the year
      });

      let barSeries = [...new Set(Object.values(result).flatMap(obj => Object.keys(obj)).filter(key => key !== "week"))];
      setBars(barSeries);

      return Object.values(result);
    }


  }


  function setMonthlySeries() {
    setSelectedSeries(monthlySumTrends);
    setSelectedAvgSeries(monthlyAvgTrends);
    setDataKey('month');
    let graphData = alignData(monthlySumTrends, monthlyAvgTrends, selectedKey);
    // let joinedData = joinData(monthlySumTrends, monthlyAvgTrends, selectedKey);
    setAlignedSeries(graphData);
    // setJoinSeries(joinedData);
  };

  function setWeeklySeries() {
    setSelectedSeries(weeklySumTrends);
    setSelectedAvgSeries(weeklyAvgTrends);
    setDataKey('week');
    let graphData = alignData(weeklySumTrends, weeklyAvgTrends, selectedKey);
    // let joinedData = joinData(weeklySumTrends, weeklyAvgTrends, selectedKey);
    setAlignedSeries(graphData);
    // setJoinSeries(joinedData);
  };

  function setDailySeries() {
    setSelectedSeries(dailySumTrends);
    setSelectedAvgSeries(dailyAvgTrends);
    setDataKey('day');
    let graphData = alignData(dailySumTrends, dailyAvgTrends, selectedKey);
    setAlignedSeries(graphData);
  };


  function handleAggToggle(e) {
    if (e.target.id == 'Month') {
      setMonthToggle('contained');
      setWeekToggle('outlined');
      setDayToggle('outlined');
      setMonthlySeries();
    } else if (e.target.id == 'Week') {
      setMonthToggle('outlined');
      setWeekToggle('contained');
      setDayToggle('outlined');
      setWeeklySeries();
    } else {
      setMonthToggle('outlined');
      setWeekToggle('outlined');
      setDayToggle('contained');
      setDailySeries();
    }
  }


  const handleFormatToggle = (e) => {
    if (e.target.id == 'Linechart') {
      setLineToggle('contained');
      setBarToggle('outlined');
      setRefreshKey(oldKey => oldKey + 1);
    } else if (e.target.id == 'Barchart') {
      setLineToggle('outlined');
      setBarToggle('contained');
      setRefreshKey(oldKey => oldKey + 1);
    }
  };


  function handleAgencySelect(e) {
    setAgency(e.target.value);
    setMonthToggle('contained');
    setWeekToggle('outlined');
    setDayToggle('outlined');
    setMonthlySeries();
    setRefreshKey2(oldKey => oldKey + 1);
  }


  const clearFilters = () => {

    setPeriod('all');
    setService('tous');
    setSelectedRoutes(['all']);

    setPeriodV(t('compareperiods.all'));
    setServiceV(t('compareperiods.all'));
    setSelectedRoutesV(t('compareperiods.all'));

    setAlignedSeries('');

    deleteFilterCookies();

  };

  const handleToggle = () => {
    setOpen(!open)
  };


  const handleFilters = () => {

    setFirstLoad(0);

    //Translate service filter box
    setServiceV(service == 'tous' ? t('compareperiods.all') :
      service == 'se' ? t('compareperiods.week') :
        t('compareperiods.weekends'));

    //Translate period filter box
    let periodFormat = [];
    switch (period) {
      case 'all':
        periodFormat.push(t('compareperiods.all'));
        break
      case 'morning':
        periodFormat.push(' ' + t('compareperiods.morning'));
        break
      case 'am':
        periodFormat.push(' ' + t('compareperiods.am'));
        break
      case 'op':
        periodFormat.push(' ' + t('compareperiods.offpeak'));
        break
      case 'pm':
        periodFormat.push(' ' + t('compareperiods.pm'));
        break
      case 'evening':
        periodFormat.push(' ' + t('compareperiods.evening'));
        break
    }

    setPeriodV(periodFormat);

    setSelectedRoutesV(selectedRoutes.includes('all') ? t('compareperiods.all') : selectedRoutes);

    updateFilterCookies(service, period, selectedRoutes);

    // if (recalcAvg == true) {
    //   setRefreshKey1(oldKey => oldKey + 1);
    //   setRecalcAvg(false);
    // }

    setRefreshKey(oldKey => oldKey + 1);

  }


  const CustomTooltip = ({ active, payload }) => {
    // If 2 series (sum + avg)
    if (active, payload[0], payload[1]) {
      return (
        <div className="custom-tooltip">
          <p className="label">
            {payload[0] ? dataKey == 'day' ? t('trends.hover.day') : dataKey == 'week' ? t('trends.hover.week') : t('trends.hover.month') : ''}
            {payload[0] ? payload[0].payload.date : ''}<br />
            {translatedKey} : {
              translatedKey == t('dashboard.kpi.occ') ? payload[0] ? payload[0].value.toFixed(2) : '' :
                translatedKey == t('dashboard.kpi.otp') || translatedKey == t('dashboard.kpi.hpct') || translatedKey == t('dashboard.kpi.kmpct') || translatedKey == t('dashboard.kpi.tripspct') ? payload[0] ? payload[0].value.toFixed(1) + '%' : '' :
                  Math.round(payload[0] ? payload[0].value : '').toLocaleString('fr-CA')}<br />
            Variation : {payload[0] ? payload[0].payload.variation ? payload[0].payload.variation.toFixed(1) + '%' : '0%' : ''}<br />
            {t('trends.avgroute')} : {
              translatedKey == t('dashboard.kpi.occ') ? payload[1] ? payload[1].value.toFixed(2) : '' :
                translatedKey == t('dashboard.kpi.otp') || translatedKey == t('dashboard.kpi.hpct') || translatedKey == t('dashboard.kpi.kmpct') || translatedKey == t('dashboard.kpi.tripspct') ? payload[1] ? payload[1].value.toFixed(1) + '%' : '' :
                  Math.round(payload[1] ? payload[1].value : '').toLocaleString('fr-CA')}<br />
          </p>
        </div>
      );
      // If 1 series (sum only)
    } else if (active, payload[0]) {
      return (
        <div className="custom-tooltip">
          <p className="label">
            {payload[0] ? dataKey == 'day' ? t('trends.hover.day') : dataKey == 'week' ? t('trends.hover.week') : t('trends.hover.month') : ''}
            {payload[0] ? payload[0].payload.date : ''}<br />
            {translatedKey} : {
              translatedKey == t('dashboard.kpi.occ') ? payload[0] ? payload[0].value.toFixed(2) : '' :
                translatedKey == t('dashboard.kpi.otp') || translatedKey == t('dashboard.kpi.hpct') || translatedKey == t('dashboard.kpi.kmpct') || translatedKey == t('dashboard.kpi.tripspct') ? payload[0] ? payload[0].value.toFixed(1) + '%' : '' :
                  Math.round(payload[0] ? payload[0].value : '').toLocaleString('fr-CA')}<br />
            Variation : {payload[0] ? payload[0].payload.variation ? payload[0].payload.variation.toFixed(1) + '%' : '0%' : ''}
          </p>
        </div>
      );
    }
    return null;
  }

  const CustomTooltipBar = ({ active, payload, label }) => {
    if (label && payload) {
      return (
        <div className="custom-tooltip">
          <div className="label">
            {t('trends.hover.month')}
            {joinSeries.find(obj => obj.month === label).month}<br />
            {payload.map(e =>
            (<div key={e.name}><b>{e.name}</b><br />
              {translatedKey == t('dashboard.kpi.otp') ? parseFloat(e.payload[e.name]).toFixed(0)+'%' : e.payload[e.name]}<br />
            </div>
            )
            )}
            {/* {translatedKey} : {
              translatedKey == t('dashboard.kpi.occ') ? payload[0] ? payload[0].value.toFixed(2) : '' :
                translatedKey == t('dashboard.kpi.otp') || translatedKey == t('dashboard.kpi.hpct') || translatedKey == t('dashboard.kpi.kmpct') || translatedKey == t('dashboard.kpi.tripspct') ? payload[0] ? payload[0].value.toFixed(1) + '%' : '' :
                  Math.round(payload[0] ? payload[0].value : '').toLocaleString('fr-CA')}<br />
            Variation : {payload[0] ? payload[0].payload.variation ? payload[0].payload.variation.toFixed(1) + '%' : '0%' : ''}<br />
            {t('trends.avgroute')} : {
              translatedKey == t('dashboard.kpi.occ') ? payload[1] ? payload[1].value.toFixed(2) : '' :
                translatedKey == t('dashboard.kpi.otp') || translatedKey == t('dashboard.kpi.hpct') || translatedKey == t('dashboard.kpi.kmpct') || translatedKey == t('dashboard.kpi.tripspct') ? payload[1] ? payload[1].value.toFixed(1) + '%' : '' :
                  Math.round(payload[1] ? payload[1].value : '').toLocaleString('fr-CA')}<br /> */}
          </div>
        </div>
      );
    }
  }


  const renderLegend = (value, entry, index) => {
    return <span style={{ color: "black" }} className="text-color-class">{
      (selectedRoutesV.includes('all') || selectedRoutesV == t('compareperiods.all') || selectedRoutesV.length == routes.length) ?
        value + ' ' + t('trends.routesgraph') :
        selectedRoutesV.includes('all') == false && selectedRoutesV !== t('compareperiods.all') && value !== t('trends.avgroute') ?
          (selectedRoutesV.length < 10 && selectedRoutesV.length > 0) ?
            value + ' - ' + t('compareperiods.route') + ' ' + selectedRoutesV.join(',') : value + ' - ' + t('compareperiods.custom')
          :
          selectedRoutesV.includes('all') == false && value == t('trends.avgroute') ?
            value //+ ' ' + translatedKey.toLowerCase() + ' ' + t('trends.routesgraph') 
            :
            ''
    }</span>
  };


  return (
    user && userAgency ?
      <>

        <div className="row justify-content-center ps-1 pe-1">
          <div className="col-sm">
            <h1 id="page-title" className="display-5">{t('trends.title')}</h1>
            {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
              <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
            </div> : ''}
          </div>
        </div>

        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

          <TrendsDrawer
            toggle={handleToggle}
            open={open}

            service={service}
            handleDayTypeClick={handleDayTypeClick}

            period={period}
            handlePeriodClick={handlePeriodClick}

            handleRouteClick={handleRouteClick}
            routes={routes}

            handleFilters={handleFilters}
            selectedRoutes={selectedRoutes}

            setService={setService}
            setPeriod={setPeriod}
            setSelectedRoutes={setSelectedRoutes}
            handleMultiRoutes={handleMultiRoutes}

            setRecalcAvg={setRecalcAvg}
            t={t}
          />

          <div className="row justify-content-center align-items-center pt-3 pb-2">

            {Array.isArray(userAgency) && userAgency.length > 1 ?
              <div className="col-lg-3 col-sm-12">
                <select onChange={(event) => handleAgencySelect(event)} className="form-select form-select-lg mb-3 mt-3">
                  <option defaultValue>Opérateur</option>
                  {userAgency.map((e) => (
                    <option value={e} key={e}
                    >{e}</option>
                  ))}
                </select>
              </div>
              : ''}

            {alignedSeries ?
              <div className="col-lg-4 col-sm-12 text-center">
                <select
                  value={translatedKey}
                  onChange={(event) => handleKPISelect(event)}
                  className="form-select form-select-lg mb-3 mt-3"
                >
                  {kpiKeys.map((e) => (
                    <option value={e} key={e}>
                      {e}
                    </option>
                  ))}
                </select>
              </div>
              : ''}

          </div>

          {
            //Filters
          }

          <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 justify-content-center">

            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={serviceV}
                kpi2={''}
                desc={t('compareperiods.days')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={periodV}
                kpi2={''}
                desc={t('compareperiods.period')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={(selectedRoutesV.length == routes.length || selectedRoutesV.includes(t('compareperiods.all'))) || selectedRoutesV == t('compareperiods.all') ? t('compareperiods.all') : (selectedRoutesV.length < 10 && selectedRoutesV.length > 0 && selectedRoutesV.includes(t('compareperiods.all')) == false) ? selectedRoutesV.join(',') : t('compareperiods.custom')}
                kpi2={''}
                desc={t('compareperiods.route')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2 text-center">
              <ButtonGroup orientation="vertical" aria-label="Vertical button group">
                <Button
                  variant="outlined"
                  onClick={handleToggle}
                  disableElevation
                  startIcon={<TuneIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "grey", color: "white" }}>
                  {t('compareperiods.filters')}
                </Button>
                <Button
                  variant="outlined"
                  onClick={clearFilters}
                  disableElevation
                  startIcon={<ClearIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "red", color: "white" }}>
                  {t('compareperiods.clear')}
                </Button>
              </ButtonGroup>
            </div>
          </div>

          {loading == 0 ? '' :
            <div className="mapspinner">
              <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
            </div>}


          {alignedSeries ?
            <div className="row justify-content-center">
              <div className="row justify-content-center pt-2">
                <div className="col text-center">
                  <ButtonGroup variant="outlined" aria-label="outlined primary button group">
                    <Button id="Month" variant={monthToggle} onClick={(e) => handleAggToggle(e)}>{t('trends.month')}</Button>
                    <Button style={{ display: lineToggle == 'contained' ? 'block' : 'none' }} id="Week" variant={weekToggle} onClick={(e) => handleAggToggle(e)}>{t('trends.week1')}</Button>
                    <Button style={{ display: lineToggle == 'contained' ? 'block' : 'none' }} id="Day" variant={dayToggle} onClick={(e) => handleAggToggle(e)}>{t('trends.day')}</Button>
                  </ButtonGroup>
                </div>
              </div>

              <div className="col-lg col-sm-12 pt-3 pb-3">
                <h3 className="text-center pt-2 pb-2">{(selectedRoutesV.length == routes.length || selectedRoutesV.includes(t('compareperiods.all'))) ?
                  translatedKey + ' ' + ' - ' + t('compareperiods.all') + ' ' + t('compareperiods.routes') :
                  (selectedRoutesV.length < 10 && selectedRoutesV.length > 0 && selectedRoutesV.includes(t('compareperiods.all')) == false) ?
                    translatedKey + ' - ' + t('compareperiods.route') + ' ' + selectedRoutesV.join(',') : translatedKey + ' - ' + t('compareperiods.custom')}</h3>

                <div className="row" style={{ display: dataKey == 'month' ? 'block' : 'none' }}>
                  <div className="col me-1 text-end">
                    <ButtonGroup variant="outlined" aria-label="outlined secondary button group">
                      <Button id="Linechart" variant={lineToggle} onClick={(e) => handleFormatToggle(e)}><i className="fa-solid fa-chart-line no-pointer-events"></i></Button>
                      <Button id="Barchart" variant={barToggle} onClick={(e) => handleFormatToggle(e)}><i className="fa-solid fa-chart-simple no-pointer-events"></i></Button>
                    </ButtonGroup>
                  </div>
                </div>

                <div className="me-1 border rounded" style={{ backgroundColor: "white" }}>

                  {lineToggle == 'contained' ?
                    <ResponsiveContainer width="100%" height={425}>
                      <ComposedChart
                        width={500}
                        height={300}
                        data={alignedSeries}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 90,
                        }}
                      >
                        <CartesianGrid vertical={false} strokeDasharray="3 3" />

                        <XAxis
                          xAxisId={0} dx={-5} textAnchor="end" dataKey="date"
                          tickLine={true} tick={{ fontSize: 13, angle: -90 }}
                          allowDuplicatedCategory={false}
                        />
                        <YAxis allowDataOverflow={false} />
                        <Tooltip
                          content={<CustomTooltip />}
                        />
                        <Line
                          dot={{ stroke: '#79508f', strokeWidth: 2, r: 3, fill: 'white' }}
                          strokeWidth={3}
                          dataKey="value2"
                          fill="#79508f"
                          stroke="#79508f"
                          isAnimationActive={false}
                          legendType="circle"
                          // label={
                          //   <CustomizedLabel />
                          // }
                          name={translatedKey}
                        />

                        {(selectedRoutesV.includes('all') == false && selectedRoutesV !== t('compareperiods.all') && selectedRoutesV.length !== routes.length && selectedRoutesV.length > 0) ?
                          <Line
                            dot={{ stroke: '#000000', strokeWidth: 2, r: 3, fill: 'white' }}
                            strokeWidth={3}
                            dataKey="value1"
                            fill="#000000"
                            stroke="#000000"
                            isAnimationActive={false}
                            legendType="circle"
                            //hide={selectedRoute == 'tous'}
                            // label={
                            //   <CustomizedLabel />
                            // }
                            name={t('trends.avgroute')}
                          />
                          : ''}
                        <Legend
                          verticalAlign="bottom"
                          wrapperStyle={{
                            bottom: '5%',
                            right: '0%',
                          }}
                          formatter={(value, entry, index) =>
                            renderLegend(value, entry, index)
                          } />

                      </ComposedChart>
                    </ResponsiveContainer>
                    :
                    <ResponsiveContainer width="100%" height={425}>
                      <BarChart
                        barCategoryGap="20%"
                        width={500}
                        height={300}
                        data={joinSeries}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 90,
                        }}
                      >
                        <CartesianGrid vertical={false} strokeDasharray="3 3" />

                        <XAxis
                          xAxisId={0} dx={-5} textAnchor="end" dataKey={dataKey}
                          tickLine={true} tick={{ fontSize: 13, angle: -90 }}
                        //allowDuplicatedCategory={false}
                        />
                        <YAxis allowDataOverflow={false} />
                        <Tooltip
                          content={<CustomTooltipBar />}
                        />
                        {bars.map((e, i) => (
                          <Bar
                            key={e}
                            dataKey={e}
                            fill={colorGradient[i]}
                            isAnimationActive={false}
                            // label={
                            //   <CustomizedLabel />
                            // }
                            name={e}
                          />
                        ))
                        }
                        <Legend />

                      </BarChart>
                    </ResponsiveContainer>
                  }
                </div>
              </div>
            </div>
            : ''}


        </div>
      </> :
      <>
        <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="d-flex justify-content-center">
            <div className="row">
              <div className="col-sm">
                <h1 className="display-5">{t('data.loading')}</h1>
                <div className="d-flex justify-content-center">
                  <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

  )

}

export default Trends